import { TRAINING_OFFERS } from './trainingOffers';

const TIME_LIMITS = Object.freeze({
  '1': 1,
  '2-3': 3,
  '6': 6,
  '12': 12,
});

const GOAL_PREFERENCES = Object.freeze({
  foundations: Object.freeze(['essential', 'progression', 'immersion']),
  practice: Object.freeze(['progression', 'immersion', 'professional']),
  project: Object.freeze(['immersion', 'progression', 'professional']),
  career: Object.freeze(['professional', 'immersion', 'expert']),
  expertise: Object.freeze(['expert', 'professional', 'immersion']),
});

const EXPERIENCE_PREFERENCES = Object.freeze({
  beginner: Object.freeze(['essential', 'progression', 'immersion']),
  practicing: Object.freeze(['progression', 'immersion', 'professional']),
  advanced: Object.freeze(['professional', 'expert', 'immersion']),
});

export const durationInMonths = ({ value, unit }) => (
  unit === 'year' ? value * 12 : value
);

const preferenceScore = (preferences, key) => {
  const index = preferences.indexOf(key);
  return index === -1 ? 0 : preferences.length - index;
};

export const getComparatorRecommendation = (answers = {}) => {
  const { goal, time, experience } = answers;
  const maxMonths = TIME_LIMITS[time];
  const goalPreferences = GOAL_PREFERENCES[goal];
  const experiencePreferences = EXPERIENCE_PREFERENCES[experience];

  if (!maxMonths || !goalPreferences || !experiencePreferences) {
    return undefined;
  }

  const eligible = TRAINING_OFFERS
    .filter((offer) => durationInMonths(offer.duration) <= maxMonths)
    .map((offer) => ({
      offer,
      score: (preferenceScore(goalPreferences, offer.key) * 2)
        + preferenceScore(experiencePreferences, offer.key),
    }))
    .sort((first, second) => (
      second.score - first.score
      || first.offer.total - second.offer.total
      || durationInMonths(first.offer.duration) - durationInMonths(second.offer.duration)
    ));

  const match = eligible[0];

  if (!match) {
    return undefined;
  }

  const idealOfferKey = goalPreferences[0];

  return {
    offerKey: match.offer.key,
    idealOfferKey,
    isClosest: !eligible.some(({ offer }) => offer.key === idealOfferKey),
  };
};
